import request from "../utils/request";

/**
 * Tüm cari hesapları getirir.
 */
export async function getAllCari() {
  return request.get("Cari");
}

/**
 * Belirli bir cari hesabı ID'ye göre getirir.
 * @param {number} id - Cari hesap ID'si
 */
export async function getCariById(id) {
  return request.get(`Cari/${id}`);
}

/**
 * Yeni bir cari hesap oluşturur.
 * @param {Object} cari - Cari hesap bilgileri
 * @param {string} cari.name - Cari hesap adı
 * @param {string} cari.email - Cari hesap email
 * @param {string} cari.phone - Cari hesap telefon
 * @param {string} cari.address - Cari hesap adresi
 */
export async function createCari(cari) {
  return request.post("Cari", cari);
}

/**
 * Mevcut bir cari hesabı günceller.
 * @param {Object} cari - Güncellenecek cari hesap bilgileri
 * @param {number} cari.id - Cari hesap ID'si
 * @param {string} cari.name - Cari hesap adı
 * @param {string} cari.email - Cari hesap email
 * @param {string} cari.phone - Cari hesap telefon
 * @param {string} cari.address - Cari hesap adresi
 */
export async function updateCari(cari) {
  return request.put("Cari", cari);
}

/**
 * Bir cari hesabı siler.
 * @param {number} id - Silinecek cari hesap ID'si
 */
export async function deleteCari(id) {
  return request.delete(`Cari/${id}`);
}

/**
 * Cari hesapları filtreleyerek listeler.
 * @param {Object} payload - Filtreleme parametreleri
 */
export async function getCariList(payload) {
  return request.get("Cari/List", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      name: payload.name,
      email: payload.email,
      phone: payload.phone,
      address: payload.address,
      branchId: payload.branch != null && payload.branch != undefined && payload.branch.id > 0 ? payload.branch.id : null,
    }
  });
}

/**
 * Cari hesapların Excel raporunu indirir.
 * @param {Object} payload - Filtreleme parametreleri
 */
export async function getCariExcel(payload) {
  return request.get("Cari/GetExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      name: payload.name,
      email: payload.email,
      phone: payload.phone,
      address: payload.address,
      branchId: payload.branch != null && payload.branch != undefined && payload.branch.id > 0 ? payload.branch.id : null,
    }
  });
}

/**
 * Cari bakiye özetini getirir.
 */
export async function getCariBalance(id) {
  return request.get(`Cari/balance/${id}`);
}

/**
 * Cari ödeme kaydeder.
 */
export async function saveCariPayment(payload) {
  return request.post("Cari/payment", payload);
}

/**
 * Cari raporunu listeler.
 */
export async function getCariReport(payload) {
  return request.get("Cari/report", {
    params: {
      startDate: payload.startDate,
      endDate: payload.endDate,
      cariId: payload.cariId
    }
  });
}

/**
 * Cari hareket detaylarını getirir (siparişler ve ödemeler).
 */
export async function getCariTransactions(id) {
  return request.get(`Cari/transactions/${id}`);
}

